import { render, staticRenderFns } from "./ViewVersionSwitcher.vue?vue&type=template&id=5fb81cfd&scoped=true"
import script from "./ViewVersionSwitcher.vue?vue&type=script&lang=ts"
export * from "./ViewVersionSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./ViewVersionSwitcher.vue?vue&type=style&index=0&id=5fb81cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb81cfd",
  null
  
)

export default component.exports